<template lang="pug">
#colors
  .editor
    //- span SCSS
    vue-markdown(:source="contenthtml",ref="markd")
  //- editor(ref='css', v-model='contentcss', @init='editorInit', lang='scss', theme='dracula', width='100%', height='100%')
  //- .editor-html
  //-   span HTML
  //-   editor(ref='html', v-model='contenthtml', lang='html', theme='dracula', width='100%', height='100%')
  .content
    .item(:class="{'selected': selected=='material'}",@click="selectItem('material')")
      .title
        | Material UI Colors 
        a(href='https://materialuicolors.co/', target='_blank') https://materialuicolors.co/
      .content
        .block(:key="key",v-for="(val,key) in col['material']",:style="{'background':val}")
</template>
<style lang="scss">



$color-red: #F44336;
$color-pink: #E91E63; 
$color-purple: #673AB7;

.block {
 width: 50px;
 height: 50px;
 display: inline-block;
 background: white;
 margin: 0;
}

#colors {
  overflow: auto;
  display: grid;
  height: 100%;
  grid-template-areas: "cnt editor"
                       "cnt editor";


  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;


  .content {
    overflow-x: none;
    overflow-y: auto;
    grid-area: cnt;
    overflow: auto;

    // width: 100%;
    border-right: 1px dashed  ;

    .selected {
       background-color: rgba($color-purple,0.3);
    }
    .item {
      height: inherit;
          display: flex;
    flex-wrap: wrap;

      cursor: pointer;
      border-bottom: 1px solid rgba(255,255,255,0.1);

      &:hover {
        background-color: rgba($color-purple,0.2);

        .title {
          color: #42b983;
        }
        
      }

      >.content {
        padding: 15px;
      }

      >.title {
        height: 2rem;
        padding-top: 15px;
        font-size: 16px;
        text-align: left;
        padding-left: 15px;

      }
    }
  } 


  .editor {
    overflow: auto;
    grid-area: editor;
    padding: 0;
    position: relative;
    text-align: left;
    padding: 10px;
    margin: 0;

    // >span {
    //   position: absolute ;
    //   color: white;
    //   z-index: 50;
    //   right: 30px;
    //   top : 4px;
    // }
  }

 

}

</style>

<script>
var VueMarkdown = require('vue-markdown');


const colors = {
  'material': {
    'red': '#F44336',
    'pink': '#E91E63',
    'purple': '#9C27B0',
    'deep-purple': '#673AB7',
    'indigo': '#3F51B5',
    'blue':  '#2196F3',
    'light-blue': '#03A9F4',
    'cyan': '#00BCD4',
    'teal': '#009688',
    'green': '#4CAF50',
    'light-green': '#8BC34A',
    'lime': '#CDDC39',
    'yellow': '#FFEB3B',
    'amber': '#FFC107',
    'orange': '#FF9800',
    'deep-orange': '#FF5722',
    'brown': '#795548',
    'grey': '#9E9E9E',
    'blue-grey': '#607D8B',
    'black': '#000',
    'white': '#fff'
  }
}


// const colors_css = {
//   'material': 

// }

export default {
  components: {
        'vue-markdown': require('vue-markdown').default,
        // editor: require('vue2-ace-editor'),
    },
  data() {
    return {
    contentcss: '',
    contenthtml: '',
    col: colors,
    selected: 'material',
    options: {
      'ReadOnly': "true"
    }
    }
  },

  computed: {
    // selected_css() {
    //   for(let key of Object.keys(colors[this.selected])) {
         
    //   }
    //   return String(colors[this.selected]);
    // },

    // selected_html() {
    //   return '';
    // }
  },
  mounted() {
    this.selectItem('material');
  },

  methods: {
    selectItem(name) {
      this.selected = name;
      // this.contentcss = colors_css[name];
      this.contenthtml = '';
      this.readText();
    },
  // editorInit: function () {
  //           require('brace/ext/language_tools') //language extension prerequsite...
  //           require('brace/mode/html')                
  //           require('brace/mode/javascript')    //language
  //           require('brace/mode/less')
  //           require('brace/mode/scss')
  //           require('brace/theme/dracula')
  //           require('brace/snippets/javascript') //snippet
  //       },

   async readText(name) {
      this.contenthtml = await this.$get('colors/material.md');
      // Prism.highlightAll();
      this.$higlight_all(this);



     
      // Hljs.highlightBlock(blocks);

      // let src = this.$md.render(text);
      // console.log(src);
    }
  }
}
</script>
